import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';

@Component({
    selector: 'ok-expansion-panel',
    template: `
        <div class="expansionPanel">
            <div
                class="expansionPanel_header"
                [ngClass]="headerCSS"
                (click)="toggleExpansionPanel()"
            >
                <ng-content header select="[header]"></ng-content>
                <abstract-icon
                    style="transform-origin: 50% 40%;padding:0px 7px"
                    class="rotate"
                    [iconType]="useAlternativeArrowIcon()"
                    [iconSize]="IconSize.Medium"
                    [ngClass]="{ 'rotate--down': isExpanded }"
                ></abstract-icon>
            </div>
            <div
                [ngClass]="contentCSS"
                [hidden]="!isExpanded"
                class="expansionPanel_content"
            >
                <ng-content content select="[content]"></ng-content>
            </div>
        </div>
    `,
    standalone: false
})
export class OkExpansionPanelComponent {
    @Input()
    headerCSS?: string;
    @Input()
    contentCSS?: string;
    @Input()
    isExpanded: boolean;
    @Input()
    isAlternativeArrowIcon?: boolean;

    @Output()
    onExpand: EventEmitter<void> = new EventEmitter();
    @Output()
    onClose: EventEmitter<void> = new EventEmitter();
    IconType = IconType;
    IconSize = IconSize;

    toggleExpansionPanel() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.onExpand.emit();
        } else {
            this.onClose.emit();
        }
    }

    useAlternativeArrowIcon() {
        return this.isAlternativeArrowIcon === true
            ? IconType.CircleAngleDown
            : IconType.ChevronDown;
    }
}
